module.exports = __webpack_public_path__ + "img/visa.77441b38.svg";